/** Machine codes raised by the SQL API, with client-ready Russian messages. */
export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
    public status?: number,
  ) {
    super(message);
  }
}

const MESSAGES: Record<string, string> = {
  slot_unavailable: 'Это время уже заняли. Выберите другое.',
  slot_too_soon: 'Слишком близко к текущему времени — выберите время позже.',
  slot_too_far: 'Запись на эту дату пока закрыта.',
  slot_outside_hours: 'Студия не работает в это время.',
  slot_not_aligned: 'Выберите время из списка.',
  slot_in_past: 'Это время уже прошло.',
  services_required: 'Выберите услугу.',
  service_unavailable: 'Услуга недоступна для онлайн-записи.',
  one_main_service_only: 'Можно выбрать только одну основную услугу.',
  no_resource_for_services: 'Эти услуги нельзя выполнить вместе в одном боксе.',
  price_missing: 'Для выбранного класса авто нет цены — уточните по телефону.',
  vehicle_class_invalid: 'Выберите класс автомобиля.',
  customer_name_invalid: 'Укажите имя.',
  customer_phone_invalid: 'Проверьте номер телефона.',
  vehicle_invalid: 'Укажите марку и модель автомобиля.',
  vehicle_plate_required: 'Укажите госномер.',
  vehicle_plate_invalid: 'Проверьте госномер.',
  idempotency_conflict: 'Запрос уже был отправлен с другими данными. Обновите страницу.',
  idempotency_key_required: 'Обновите страницу и попробуйте снова.',
  rate_limited: 'Слишком много запросов. Подождите минуту.',
  tenant_not_found: 'Студия не найдена.',
  booking_not_found: 'Запись не найдена или ссылка недействительна.',
  cancel_window_closed: 'Отменить онлайн уже нельзя — позвоните в студию.',
  booking_not_cancellable: 'Эту запись уже нельзя отменить.',
  booking_not_reschedulable: 'Эту запись нельзя перенести.',
  status_transition_invalid: 'Такое изменение статуса невозможно.',
  refund_exceeds_paid: 'Возврат больше полученной суммы.',
  amount_invalid: 'Проверьте сумму.',
  forbidden: 'Нет доступа к этой студии.',
  not_authenticated: 'Войдите в кабинет.',
  storage_path_invalid: 'Не удалось сохранить файл.',
  media_not_found: 'Фотография не найдена.',
  range_invalid: 'Неверный период.',
  email_invalid: 'Проверьте e-mail.',
  demo_tenant_cannot_go_live: 'Демо-студию нельзя перевести в рабочий режим.',
};

export function describeError(code: string, hint?: string | null): string {
  return MESSAGES[code] ?? hint ?? (code.includes('Failed to fetch') || code.includes('NetworkError') ? 'Нет соединения с сервером.' : 'Что-то пошло не так. Попробуйте ещё раз.');
}

export function errorMessage(e: unknown): string {
  if (e instanceof ApiError) return e.message;
  if (e instanceof Error) return describeError(e.message);
  return describeError('unknown_error');
}
